import { getCachedSession } from "./session-cache";

export async function getSession() {
	const response = await getCachedSession();
	return response?.data?.session ?? null;
}

export async function isAuthenticated() {
	const session = await getSession();
	return !!session;
}
